import { Button, Dialog, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import AutoCompleteComponent from "../../Components/AutoComplete/AutoComplete";
import OutboundFeedsModal from "../../Components/Modal/OutboundFeedsModal";
import Signifier from "../../Components/Signifier";
import OutboundFeedTableCell from "../../Components/Table/OutboundFeedTableCell";
import SortableTable from "../../Components/Table/SortableTable";
import { getAllClients } from "../../Services/API/ClientManagement";
import { getOutboundFeeds } from "../../Services/API/OutboundFeeds";

function FeedsPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "60%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    addButton: {},
    autocomplete: {
      width: "20%",
      paddingBottom: "20px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
      [theme.breakpoints.down("sm")]: {
        position: "unset",
      },
    },
  }));

  const classes = useStyles();

  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  axios.defaults.headers.common["client"] = selectedClient?.id;

  const columns = [
    { label: "Name", propName: "name" },
    { label: "Date Created", propName: "dateCreated" },
    { label: "Date Updated", propName: "dateLastUpdated" },
    { label: "Link", propName: "id" },
  ];

  const convertDate = (date) => {
    var newDate = new Date(date).toLocaleDateString("en-US");
    return newDate;
  };

  const handleClientChange = (event, value) => {
    setSelectedClient(value);
  };

  const compare = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  useEffect(() => {
    setLoading(true);
    getAllClients()
      .then((response) => {
        response.sort((a, b) => {
          const order = compare(a.shortName, b.shortName);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        setAllClients(response);
      })
      .catch((err) => console.error("Failed to load clients:", err))
      .finally(() => setLoading(false));
  }, []);

  const loadFeeds = useCallback(() => {
    if (selectedClient === null || selectedClient === undefined) return;
    setLoading(true);
    setError(false);
    return getOutboundFeeds(selectedClient.id)
      .then((response) => {
        for (var i in response) {
          response[i].dateCreated = convertDate(response[i].dateCreated);
          response[i].dateLastUpdated = convertDate(
            response[i].dateLastUpdated
          );
        }
        setData(response);
      })
      .catch((err) => {
        console.error("Failed to load outbound feeds:", err);
        setError(true);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClient]);

  useEffect(() => {
    loadFeeds();
  }, [loadFeeds]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Account Added"
        error={showError}
      />
      <div className={classes.root}>
        <div className={classes.autocomplete}>
          <AutoCompleteComponent
            dropdownItems={allClients}
            propertyName="shortName"
            label="Search for clients..."
            onChange={handleClientChange}
          />
        </div>
        {selectedClient !== null ? (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Button
                  color="primary"
                  className={classes.addButton}
                  style={{ color: "white", marginBottom: "10px" }}
                  type="submit"
                  variant="contained"
                  onClick={() => setOpenModal(true)}
                >
                  Add Feed
                </Button>
              </Grid>
            </Grid>
            <SortableTable
              columns={columns}
              tableData={data}
              loading={loading}
              error={error}
              onRetry={loadFeeds}
              rowComponent={OutboundFeedTableCell}
            />
          </>
        ) : (
          <div className={classes.hint}>
            <span>Select a client</span>
          </div>
        )}
      </div>
      <Dialog
        open={openModal}
        fullWidth
        maxWidth="lg"
        onClose={() => setOpenModal(false)}
      >
        <OutboundFeedsModal
          openModal={setOpenModal}
          setData={setData}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
          selectedClient={selectedClient}
        />
      </Dialog>
    </>
  );
}

export default FeedsPage;
